import { ParamContextProvider, useParamContext } from 'contexts/ParamContext';

import { DOCUMENT_TYPE } from 'api/documents/documents.model';
import Loading from 'components/Icons/Loading';
import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import useCategoriesQuery from 'hooks/useCategoriesQuery';
import { useCertificatesQuery } from 'hooks/useCertificatesQuery';
import { CATEGORY_TYPE } from 'models/documents.model';
import AccessDenied from 'pages/AccessDenied';

import NewCertContent from './NewCertContent';
import { useCategoryConfig } from './hooks/useCategoryConfig';

const NewCert = () => {
  const category = useParamContext<CATEGORY_TYPE>();
  const { currentUser } = useAuthenticatedContext();

  const { data: categories = {}, isLoading: isCategoriesLoading } = useCategoriesQuery();

  const { data, isLoading: isCertificatesLoading } = useCertificatesQuery(
    {
      documentType: DOCUMENT_TYPE.PUBLIC,
      categoryId: (() => {
        switch (category) {
          case CATEGORY_TYPE.BATTERY_CELLS:
            return categories?.[CATEGORY_TYPE.CHEMISTRY];
          case CATEGORY_TYPE.BATTERY_PACKS:
            return categories?.[CATEGORY_TYPE.BATTERY_CELLS];
          default:
            return categories?.[CATEGORY_TYPE.BATTERY_PACKS];
        }
      })(),
    },
    {
      enabled: !isCategoriesLoading,
    }
  );

  const productIds = data?.rows?.reduce<string[]>((prev, next) => {
    if (next.additionalDetails?.productId && !prev.includes(next.additionalDetails.productId)) {
      prev.push(next.additionalDetails.productId);
    }
    return prev;
  }, []);

  const config = useCategoryConfig(category, productIds);

  if (isCategoriesLoading || isCertificatesLoading) {
    return <Loading />;
  }

  const categoryId = categories[category];

  if (
    !categoryId ||
    !config ||
    ![currentUser?.category, CATEGORY_TYPE.CERTIFICATE].includes(category)
  ) {
    return <AccessDenied />;
  }

  return <NewCertContent categoryId={categoryId} type={category} config={config} />;
};

const NewCertPage = () => (
  <ParamContextProvider paramName="category" enumName={CATEGORY_TYPE}>
    <NewCert />
  </ParamContextProvider>
);

export default NewCertPage;
